import React from "react";
import { StarIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { testimonials } from "../../data/content";
export function Testimonials() {
  return <section className="w-full bg-brand-mist px-5 py-16 md:py-24" data-id="element-295" data-mp="3mf7pufvy5mbi">
      <div className="mx-auto max-w-5xl" data-id="element-296" data-mp="3r7sgj8jk3jat">
        <SectionHeading eyebrow="Creators inside The Aroma Lab" title="From random recipes to their own collections" data-id="element-297" data-mp="3r8ttxjo1ohvp" />

        <ul className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-298" data-mp="3k720vckjqb">
          {testimonials.map((t, i) => <li key={t.name} className={`flex flex-col overflow-hidden rounded-3xl bg-paper ${i === 0 ? "md:col-span-2 md:flex-row" : ""}`} data-id="element-299" data-mp="44nq0w8oyvvr" data-mpi={i}>
              <img src={t.image} alt={`${t.name}, ${t.role}`} className={`aspect-[4/3] w-full object-cover ${i === 0 ? "md:aspect-auto md:w-2/5" : ""}`} data-id="element-300" data-mp="dywf19yik6p6" />
              <div className="flex flex-1 flex-col p-6 md:p-8" data-id="element-301" data-mp="2fu6q7k1ynbnp">
                <div className="flex gap-0.5 text-brand-amber" aria-label="5 out of 5 stars" data-id="element-302" data-mp="1sm3vxu0ni4f4">
                  {Array.from({
                length: 5
              }).map((_, s) => <StarIcon key={s} className="h-5 w-5 fill-current" aria-hidden="true" data-id="element-303" data-mp="1iu80kqpy8sel" data-mpi={s} />)}
                </div>
                <blockquote className={`mt-3 font-serif leading-snug text-ink ${i === 0 ? "text-2xl md:text-3xl" : "text-xl"}`} data-id="element-304" data-mp="1eufq28gzwc6l">
                  “{t.quote}”
                </blockquote>
                <div className="mt-auto pt-5" data-id="element-305" data-mp="26i7nffk53ynw">
                  <p className="font-bold text-ink" data-id="element-306" data-mp="22hxjs9jtlkc7">{t.name}</p>
                  <p className="text-sm text-ink/60" data-id="element-307" data-mp="22kjqy82stxtw">{t.role}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mt-12" data-id="element-308" data-mp="r4la3i1dq7i4">
          <CtaButton label="I Want Results Like These" data-id="element-309" data-mp="r4v3zgpjoyt3" />
        </div>
      </div>
    </section>;
}